// Client-side twin of ApplicationHelper#signed_money_text, for totals the
// server cannot print because they change on the device (a Due today total
// after an expense is marked paid). The server hands over the pieces it would
// have used — symbol, symbol side, separators, direction — so the result
// matches what it renders: two decimals with trailing zeros stripped
// (smart_number), the delimiter from the locale, the sign on the reading-start
// side ("+€389.35" in English, "€389.35+" in Arabic).
export function moneyText(amount, format, sign = "") {
  const [whole, fraction] = Math.abs(Number(amount) || 0).toFixed(2).split(".")
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, format.delimiter)
  // format.fixed (web dashboard) keeps both decimals, as the web mockup prints them.
  const trimmed = format.fixed ? fraction : fraction.replace(/0+$/, "")
  const number = trimmed ? `${grouped}${format.separator}${trimmed}` : grouped
  const body = format.prefix ? `${format.symbol}${number}` : `${number}${format.symbol}`

  if (!sign) return body
  return format.rtl ? `${body}${sign}` : `${sign}${body}`
}
